import { render } from "./MandateFailure.vue?vue&type=template&id=2e64d548&scoped=true"
import script from "./MandateFailure.vue?vue&type=script&lang=js"
export * from "./MandateFailure.vue?vue&type=script&lang=js"

import "./MandateFailure.vue?vue&type=style&index=0&id=2e64d548&lang=scss&scoped=true"

import exportComponent from "D:\\Epaylater Projects\\microapp-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e64d548"]])

export default __exports__